var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('polygon',{staticClass:"rightPolygon",attrs:{"points":_vm.rightPolygon}})])
}
var staticRenderFns = []

export { render, staticRenderFns }